import { Component, CustomComponentManager, SelectManager } from '@easytwin/runtime';
import { message, Modal, Tooltip } from '@easyv/react-components';
import * as React from 'react';
import { useRequest } from 'ahooks';
import { observer } from 'mobx-react-lite';
import { ArrowBigUpOutlined } from '@easyv/react-icons';

interface FuncCompUpgradeVProps {
  comps: Component[] | undefined;
}

export const FuncCompUpgradeV: React.FC<FuncCompUpgradeVProps> = observer((props) => {
  const { comps } = props;
  const compsVersion = comps?.reduce((str, item) => {
    return str + item.version;
  }, '');
  const { data: isNeedUpdating } = useRequest(
    async () => {
      if (!comps) return;
      let result = false;
      for (let comp of comps) {
        if (!(comp instanceof Component)) {
          return false;
        }

        const customComponentManager = comp.engine.getManager(CustomComponentManager);
        result = await customComponentManager.isComponentStale(comp);
        if (result) break;
      }
      return result;
    },
    {
      refreshDeps: [compsVersion],
    },
  );

  const updateModule = () => {
    Modal.confirm({
      title: '更新模块',
      content: '更新后有一定可能不兼容导致功能不用，如有重要数据请备份场景或拷贝对应内容后更新',
      okButtonProps: { size: 'small' },
      cancelButtonProps: { size: 'small' },
      async onOk() {
        try {
          if (!comps) return;
          const comp = comps[0];
          if (!(comp instanceof Component)) return;
          const scene = comp.scene;
          const engine = comp.engine;
          const customComponentManager = engine.getManager(CustomComponentManager);

          const latest = await customComponentManager.getComponentLastVersion(comp.type);
          await scene.updateComponentVersion(
            comps.map((a) => {
              return { comp: a, version: latest };
            }),
          );
          const module = customComponentManager.get(comp.type, latest);
          if (!module) {
            console.warn('模块升级: 找不到新版组件的module');
            return;
          }
          message.success(`${comp.name}已更新`);
        } catch (err) {
          console.trace((err as Error).message);
          message.error((err as Error).message);
        }
      },
    });
  };

  return (
    isNeedUpdating && (
      <Tooltip content='更新'>
        <div>{isNeedUpdating}</div>
        <div
          className='w-6 h-6 text-primary cursor-pointer hover:bg-FFFFFF0A flex items-center justify-center rounded'
          onClick={async (e) => {
            e.stopPropagation();
            updateModule();
          }}
        >
          <ArrowBigUpOutlined size={14} />
        </div>
      </Tooltip>
    )
  );
});
